<template>
    <g class="elct-breadboard">
        <g transform=scale(2.0)>
        <text transform="matrix(1 0 0 1 310 255)" class="name"
            >브레드보드{{ number }}</text
        >
        <g>
            <path
                class="border"
                style="fill-rule:nonzero;fill:rgb(85.098039%,85.098039%,85.098039%);fill-opacity:1.0;"
                d="M 375.902344 243.925781 L 72.0625 243.925781 L 72.0625 48.867188 L 375.902344 48.867188 Z M 375.902344 243.925781 "
            />
            <path
                style="fill:none;stroke-width:0.75;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(90.588235%,11.764706%,10.196078%);stroke-opacity:1;stroke-miterlimit:10;"
                d="M 570.967877 377.078478 L 133.281972 376.610959 "
                transform="matrix(0.635899,0,0,0.635001,0.152319,0)"
            />
            <path
                style="fill:none;stroke-width:0.75;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(11.372549%,12.54902%,53.333333%);stroke-opacity:1;stroke-miterlimit:10;"
                d="M 570.851162 347.477159 L 133.1714 346.997338 "
                transform="matrix(0.635899,0,0,0.635001,0.152319,0)"
            />
            <path
                style="fill:none;stroke-width:0.75;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(70.980392%,70.980392%,71.372549%);stroke-opacity:1;stroke-miterlimit:10;"
                d="M 582.43048 340.710441 L 121.579797 340.710441 "
                transform="matrix(0.635899,0,0,0.635001,0.152319,0)"
            />
            <path
                style="fill:none;stroke-width:0.75;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(70.980392%,70.980392%,71.372549%);stroke-opacity:1;stroke-miterlimit:10;"
                d="M 582.909624 119.531011 L 122.058942 119.531011 "
                transform="matrix(0.635899,0,0,0.635001,0.152319,0)"
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(80%,78.823529%,78.823529%);fill-opacity:0.5;"
                d="M 361.585938 149.492188 L 72.453125 149.492188 L 72.453125 141.035156 L 361.585938 141.035156 Z M 361.585938 149.492188 "
            />
            <!--  line -->
            <path
                style="fill:none;stroke-width:0.75;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(11.372549%,12.54902%,53.333333%);stroke-opacity:1;stroke-miterlimit:10;"
                d="M 571.440878 113.330236 L 133.761116 112.862717 "
                transform="matrix(0.635899,0,0,0.635001,0.152319,0)"
            />
            <!--plus line -->
            <path
                style="fill:none;stroke-width:0.75;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(90.588235%,11.764706%,10.196078%);stroke-opacity:1;stroke-miterlimit:10;"
                d="M 571.318021 83.728917 L 133.638259 83.261398 "
                transform="matrix(0.635899,0,0,0.635001,0.152319,0)"
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 79.085938 198.414062 L 80.414062 198.890625 L 80.414062 199.472656 L 75.996094 197.898438 L 75.996094 197.175781 L 80.414062 195.535156 L 80.414062 196.160156 L 79.085938 196.648438 Z M 78.585938 196.800781 C 77.421875 197.21875 76.804688 197.453125 76.464844 197.550781 L 76.464844 197.554688 C 76.839844 197.664062 77.59375 197.921875 78.585938 198.261719 Z M 78.585938 196.800781 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 75.996094 189.726562 L 75.996094 188.03125 C 75.996094 187.097656 76.484375 186.664062 77.101562 186.664062 C 77.617188 186.664062 77.949219 186.957031 78.0625 187.300781 C 78.15625 186.988281 78.46875 186.519531 79.125 186.519531 C 79.957031 186.519531 80.421875 187.152344 80.421875 187.992188 L 80.421875 189.726562 Z M 77.832031 188.144531 C 77.832031 187.503906 77.578125 187.253906 77.148438 187.253906 C 76.753906 187.253906 76.480469 187.535156 76.480469 188.054688 L 76.480469 189.152344 L 77.832031 189.152344 Z M 79.933594 189.152344 L 79.933594 188.0625 C 79.933594 187.507812 79.671875 187.121094 79.117188 187.121094 C 78.640625 187.121094 78.316406 187.425781 78.316406 188.175781 L 78.316406 189.152344 Z M 79.933594 189.152344 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 79.164062 177.03125 C 79.914062 177.230469 80.472656 177.789062 80.472656 178.789062 C 80.472656 180.113281 79.46875 180.777344 78.222656 180.777344 C 77.019531 180.777344 75.933594 180.113281 75.933594 178.773438 C 75.933594 177.730469 76.53125 177.164062 77.269531 177.039062 L 77.269531 177.621094 C 76.785156 177.78125 76.421875 178.097656 76.421875 178.796875 C 76.421875 179.769531 77.304688 180.167969 78.203125 180.167969 C 79.066406 180.167969 79.984375 179.789062 79.984375 178.773438 C 79.984375 178.09375 79.59375 177.792969 79.164062 177.628906 Z M 79.164062 177.03125 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 75.996094 171.070312 L 75.996094 169.488281 C 75.996094 168.25 76.839844 167.40625 78.164062 167.40625 C 79.472656 167.40625 80.421875 168.222656 80.421875 169.507812 L 80.421875 171.0625 L 75.996094 171.0625 Z M 79.917969 170.484375 L 79.917969 169.558594 C 79.917969 168.515625 79.175781 168.019531 78.171875 168.019531 C 77.300781 168.019531 76.492188 168.472656 76.492188 169.550781 L 76.492188 170.480469 L 79.917969 170.480469 Z M 79.917969 170.484375 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 78.347656 158.625 L 78.347656 160.820312 L 79.914062 160.820312 L 79.914062 158.40625 L 80.414062 158.484375 L 80.414062 161.390625 L 75.996094 161.390625 L 75.996094 158.515625 L 76.5 158.515625 L 76.5 160.8125 L 77.847656 160.8125 L 77.847656 158.617188 L 78.347656 158.617188 Z M 78.347656 158.625 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 75.996094 133.738281 L 75.996094 130.898438 L 76.5 130.898438 L 76.5 133.160156 L 77.933594 133.160156 L 77.933594 131.039062 L 78.4375 131.039062 L 78.4375 133.160156 L 80.421875 133.160156 L 80.421875 133.738281 Z M 75.996094 133.738281 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 80.414062 121.476562 L 80.414062 121.925781 C 80.332031 121.957031 80.136719 121.972656 79.816406 121.984375 C 80.128906 122.175781 80.480469 122.554688 80.480469 123.355469 C 80.480469 124.632812 79.511719 125.304688 78.253906 125.304688 C 76.929688 125.304688 75.933594 124.582031 75.933594 123.246094 C 75.933594 122.21875 76.484375 121.578125 77.28125 121.449219 L 77.28125 122.035156 C 76.785156 122.1875 76.421875 122.535156 76.421875 123.261719 C 76.421875 124.28125 77.242188 124.6875 78.222656 124.6875 C 79.132812 124.6875 79.984375 124.277344 79.984375 123.277344 C 79.984375 122.289062 79.320312 122.039062 78.578125 122.039062 L 78.535156 122.039062 L 78.535156 123.285156 L 78.03125 123.285156 L 78.03125 121.46875 L 80.414062 121.46875 Z M 80.414062 121.476562 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 75.996094 115.335938 L 75.996094 114.75 L 77.839844 114.75 L 77.839844 112.453125 L 75.996094 112.453125 L 75.996094 111.867188 L 80.414062 111.867188 L 80.414062 112.453125 L 78.34375 112.453125 L 78.34375 114.75 L 80.414062 114.75 L 80.414062 115.335938 Z M 75.996094 115.335938 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 75.996094 103.339844 L 80.414062 103.339844 L 80.414062 103.925781 L 75.996094 103.925781 Z M 75.996094 103.339844 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 79.125 94.207031 C 80.121094 94.207031 80.480469 94.601562 80.480469 95.339844 C 80.480469 95.515625 80.460938 95.683594 80.433594 95.800781 L 79.945312 95.800781 C 79.964844 95.71875 79.976562 95.535156 79.976562 95.394531 C 79.976562 94.863281 79.582031 94.792969 79.148438 94.792969 L 75.996094 94.792969 L 75.996094 94.207031 Z M 79.125 94.207031 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 367.585938 198.414062 L 368.917969 198.890625 L 368.917969 199.472656 L 364.496094 197.898438 L 364.496094 197.175781 L 368.917969 195.535156 L 368.917969 196.160156 L 367.585938 196.648438 Z M 367.085938 196.800781 C 365.921875 197.21875 365.304688 197.453125 364.96875 197.550781 L 364.96875 197.554688 C 365.34375 197.664062 366.09375 197.921875 367.085938 198.261719 Z M 367.085938 196.800781 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 364.492188 189.726562 L 364.492188 188.03125 C 364.492188 187.097656 364.980469 186.664062 365.597656 186.664062 C 366.113281 186.664062 366.441406 186.957031 366.558594 187.300781 C 366.652344 186.988281 366.964844 186.519531 367.621094 186.519531 C 368.453125 186.519531 368.917969 187.152344 368.917969 187.992188 L 368.917969 189.726562 Z M 366.328125 188.144531 C 366.328125 187.503906 366.074219 187.253906 365.640625 187.253906 C 365.246094 187.253906 364.972656 187.535156 364.972656 188.054688 L 364.972656 189.152344 L 366.328125 189.152344 Z M 368.425781 189.152344 L 368.425781 188.0625 C 368.425781 187.507812 368.167969 187.121094 367.613281 187.121094 C 367.136719 187.121094 366.8125 187.425781 366.8125 188.175781 L 366.8125 189.152344 Z M 368.425781 189.152344 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 367.65625 177.03125 C 368.40625 177.230469 368.96875 177.789062 368.96875 178.789062 C 368.96875 180.113281 367.964844 180.777344 366.714844 180.777344 C 365.515625 180.777344 364.425781 180.113281 364.425781 178.773438 C 364.425781 177.730469 365.023438 177.164062 365.761719 177.039062 L 365.761719 177.621094 C 365.28125 177.78125 364.917969 178.097656 364.917969 178.796875 C 364.917969 179.769531 365.800781 180.167969 366.699219 180.167969 C 367.5625 180.167969 368.476562 179.789062 368.476562 178.773438 C 368.476562 178.09375 368.089844 177.792969 367.65625 177.628906 Z M 367.65625 177.03125 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 364.492188 171.070312 L 364.492188 169.488281 C 364.492188 168.25 365.335938 167.40625 366.660156 167.40625 C 367.96875 167.40625 368.917969 168.222656 368.917969 169.507812 L 368.917969 171.0625 L 364.492188 171.0625 Z M 368.414062 170.484375 L 368.414062 169.558594 C 368.414062 168.515625 367.671875 168.019531 366.664062 168.019531 C 365.792969 168.019531 364.988281 168.472656 364.988281 169.550781 L 364.988281 170.480469 L 368.414062 170.480469 Z M 368.414062 170.484375 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 366.84375 158.625 L 366.84375 160.820312 L 368.40625 160.820312 L 368.40625 158.40625 L 368.910156 158.484375 L 368.910156 161.390625 L 364.492188 161.390625 L 364.492188 158.515625 L 364.992188 158.515625 L 364.992188 160.8125 L 366.339844 160.8125 L 366.339844 158.617188 L 366.84375 158.617188 Z M 366.84375 158.625 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 364.492188 133.738281 L 364.492188 130.898438 L 364.992188 130.898438 L 364.992188 133.160156 L 366.429688 133.160156 L 366.429688 131.039062 L 366.933594 131.039062 L 366.933594 133.160156 L 368.917969 133.160156 L 368.917969 133.738281 Z M 364.492188 133.738281 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 368.910156 121.476562 L 368.910156 121.925781 C 368.828125 121.957031 368.628906 121.972656 368.3125 121.984375 C 368.625 122.175781 368.972656 122.554688 368.972656 123.355469 C 368.972656 124.632812 368.007812 125.304688 366.75 125.304688 C 365.425781 125.304688 364.425781 124.582031 364.425781 123.246094 C 364.425781 122.21875 364.988281 121.578125 365.777344 121.449219 L 365.777344 122.035156 C 365.28125 122.1875 364.917969 122.535156 364.917969 123.261719 C 364.917969 124.28125 365.738281 124.6875 366.714844 124.6875 C 367.625 124.6875 368.476562 124.277344 368.476562 123.277344 C 368.476562 122.289062 367.816406 122.039062 367.074219 122.039062 L 367.027344 122.039062 L 367.027344 123.285156 L 366.527344 123.285156 L 366.527344 121.46875 L 368.910156 121.46875 Z M 368.910156 121.476562 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 364.492188 115.335938 L 364.492188 114.75 L 366.335938 114.75 L 366.335938 112.453125 L 364.492188 112.453125 L 364.492188 111.867188 L 368.910156 111.867188 L 368.910156 112.453125 L 366.835938 112.453125 L 366.835938 114.75 L 368.910156 114.75 L 368.910156 115.335938 Z M 364.492188 115.335938 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 364.492188 103.339844 L 368.910156 103.339844 L 368.910156 103.925781 L 364.492188 103.925781 Z M 364.492188 103.339844 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(71.764706%,70.588235%,70.588235%);fill-opacity:1;"
                d="M 367.621094 94.207031 C 368.617188 94.207031 368.972656 94.601562 368.972656 95.339844 C 368.972656 95.515625 368.953125 95.683594 368.929688 95.800781 L 368.441406 95.800781 C 368.457031 95.71875 368.472656 95.535156 368.472656 95.394531 C 368.472656 94.863281 368.078125 94.792969 367.644531 94.792969 L 364.492188 94.792969 L 364.492188 94.207031 Z M 367.621094 94.207031 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 89.777344 209.390625 L 89.777344 210.132812 L 86.136719 210.132812 L 86.4375 210.730469 L 85.660156 210.730469 L 85.300781 210.070312 L 85.300781 209.390625 Z M 89.777344 209.390625 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 123.492188 207.90625 L 123.492188 209.601562 C 123.753906 209.632812 124.230469 209.714844 124.414062 209.746094 C 124.261719 209.582031 124.152344 209.335938 124.152344 208.953125 C 124.152344 208.148438 124.726562 207.675781 125.53125 207.675781 C 126.339844 207.675781 127.066406 208.117188 127.066406 209.199219 C 127.066406 210 126.644531 210.585938 125.921875 210.679688 L 125.921875 209.894531 C 126.238281 209.8125 126.453125 209.582031 126.453125 209.183594 C 126.453125 208.707031 126.109375 208.472656 125.597656 208.472656 C 125.125 208.472656 124.789062 208.65625 124.789062 209.167969 C 124.789062 209.59375 124.972656 209.773438 125.246094 209.886719 L 125.144531 210.605469 C 124.609375 210.488281 123.394531 210.320312 122.84375 210.25 L 122.84375 207.792969 Z M 123.492188 207.90625 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 173.503906 209.917969 L 170.269531 209.917969 C 170.375 210.117188 170.484375 210.496094 170.511719 210.710938 L 169.910156 210.710938 C 169.835938 210.34375 169.605469 209.9375 169.339844 209.683594 L 169.339844 209.117188 L 173.5 209.117188 L 173.5 209.917969 Z M 173.503906 209.917969 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 171.398438 205.054688 C 172.5 205.054688 173.574219 205.398438 173.574219 206.609375 C 173.574219 207.804688 172.542969 208.167969 171.425781 208.167969 C 170.3125 208.167969 169.277344 207.773438 169.277344 206.589844 C 169.28125 205.441406 170.261719 205.054688 171.398438 205.054688 Z M 171.425781 207.347656 C 172.195312 207.347656 172.953125 207.238281 172.953125 206.605469 C 172.953125 205.96875 172.246094 205.878906 171.414062 205.878906 C 170.613281 205.878906 169.917969 205.996094 169.917969 206.589844 C 169.910156 207.1875 170.523438 207.347656 171.425781 207.347656 Z M 171.425781 207.347656 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 220.019531 209.917969 L 216.785156 209.917969 C 216.890625 210.117188 217 210.496094 217.027344 210.710938 L 216.429688 210.710938 C 216.351562 210.34375 216.121094 209.9375 215.855469 209.683594 L 215.855469 209.117188 L 220.015625 209.117188 L 220.015625 209.917969 Z M 220.019531 209.917969 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 216.515625 205.378906 L 216.515625 207.074219 C 216.777344 207.105469 217.253906 207.1875 217.4375 207.21875 C 217.285156 207.054688 217.179688 206.808594 217.179688 206.425781 C 217.179688 205.621094 217.75 205.148438 218.558594 205.148438 C 219.367188 205.148438 220.089844 205.589844 220.089844 206.675781 C 220.089844 207.472656 219.671875 208.058594 218.945312 208.152344 L 218.945312 207.367188 C 219.265625 207.285156 219.480469 207.054688 219.480469 206.65625 C 219.480469 206.179688 219.136719 205.945312 218.621094 205.945312 C 218.152344 205.945312 217.8125 206.128906 217.8125 206.640625 C 217.8125 207.066406 218 207.246094 218.273438 207.359375 L 218.171875 208.078125 C 217.636719 207.964844 216.421875 207.792969 215.867188 207.722656 L 215.867188 205.265625 Z M 216.515625 205.378906 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 266.535156 210.707031 L 266.484375 210.707031 C 265.804688 210.707031 265.207031 210.355469 264.554688 209.46875 C 264.09375 208.851562 263.941406 208.675781 263.546875 208.675781 C 263.167969 208.675781 262.929688 208.863281 262.929688 209.269531 C 262.929688 209.714844 263.1875 209.894531 263.59375 209.957031 L 263.59375 210.71875 C 262.878906 210.65625 262.308594 210.191406 262.308594 209.265625 C 262.308594 208.234375 262.929688 207.875 263.542969 207.875 C 264.152344 207.875 264.433594 208.140625 264.984375 208.910156 C 265.375 209.441406 265.640625 209.683594 265.875 209.765625 L 265.875 207.714844 L 266.535156 207.816406 Z M 266.535156 210.707031 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 264.433594 204.058594 C 265.53125 204.058594 266.605469 204.402344 266.605469 205.613281 C 266.605469 206.808594 265.578125 207.167969 264.457031 207.167969 C 263.34375 207.167969 262.308594 206.777344 262.308594 205.59375 C 262.308594 204.445312 263.292969 204.058594 264.433594 204.058594 Z M 264.453125 206.351562 C 265.21875 206.351562 265.976562 206.242188 265.976562 205.605469 C 265.976562 204.972656 265.273438 204.882812 264.4375 204.882812 C 263.636719 204.882812 262.945312 204.996094 262.945312 205.59375 C 262.945312 206.191406 263.546875 206.351562 264.453125 206.351562 Z M 264.453125 206.351562 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 313.046875 210.707031 L 312.996094 210.707031 C 312.316406 210.707031 311.71875 210.355469 311.0625 209.46875 C 310.605469 208.851562 310.453125 208.675781 310.058594 208.675781 C 309.675781 208.675781 309.441406 208.863281 309.441406 209.269531 C 309.441406 209.714844 309.695312 209.894531 310.101562 209.957031 L 310.101562 210.71875 C 309.390625 210.65625 308.816406 210.191406 308.816406 209.265625 C 308.816406 208.234375 309.441406 207.875 310.050781 207.875 C 310.660156 207.875 310.941406 208.140625 311.496094 208.910156 C 311.882812 209.441406 312.148438 209.683594 312.386719 209.765625 L 312.386719 207.714844 L 313.046875 207.816406 Z M 313.046875 210.707031 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 309.550781 204.382812 L 309.550781 206.078125 C 309.808594 206.109375 310.285156 206.191406 310.472656 206.222656 C 310.320312 206.058594 310.210938 205.808594 310.210938 205.429688 C 310.210938 204.621094 310.78125 204.152344 311.589844 204.152344 C 312.398438 204.152344 313.121094 204.589844 313.121094 205.675781 C 313.121094 206.476562 312.703125 207.0625 311.976562 207.15625 L 311.976562 206.367188 C 312.296875 206.285156 312.511719 206.058594 312.511719 205.65625 C 312.511719 205.179688 312.167969 204.945312 311.652344 204.945312 C 311.183594 204.945312 310.839844 205.128906 310.839844 205.644531 C 310.839844 206.070312 311.023438 206.25 311.296875 206.363281 L 311.195312 207.082031 C 310.660156 206.964844 309.449219 206.792969 308.894531 206.726562 L 308.894531 204.265625 Z M 309.550781 204.382812 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 356.453125 210.660156 C 355.945312 210.597656 355.339844 210.234375 355.339844 209.246094 C 355.339844 208.3125 355.878906 207.894531 356.453125 207.894531 C 356.957031 207.894531 357.195312 208.183594 357.300781 208.425781 L 357.316406 208.425781 C 357.425781 208.121094 357.699219 207.726562 358.335938 207.726562 C 358.957031 207.726562 359.644531 208.109375 359.644531 209.253906 C 359.644531 210.320312 358.996094 210.707031 358.449219 210.757812 L 358.449219 209.988281 C 358.761719 209.925781 359.035156 209.695312 359.035156 209.234375 C 359.035156 208.75 358.722656 208.527344 358.328125 208.527344 C 357.890625 208.527344 357.648438 208.777344 357.648438 209.289062 L 357.648438 209.640625 L 357.039062 209.640625 L 357.039062 209.335938 C 357.039062 208.871094 356.871094 208.679688 356.496094 208.679688 C 356.179688 208.679688 355.96875 208.878906 355.96875 209.269531 C 355.96875 209.722656 356.21875 209.847656 356.464844 209.90625 L 356.464844 210.660156 Z M 356.453125 210.660156 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 357.464844 203.980469 C 358.5625 203.980469 359.640625 204.324219 359.640625 205.539062 C 359.640625 206.730469 358.609375 207.09375 357.488281 207.09375 C 356.375 207.09375 355.339844 206.699219 355.339844 205.519531 C 355.339844 204.367188 356.324219 203.980469 357.464844 203.980469 Z M 357.484375 206.273438 C 358.253906 206.273438 359.007812 206.164062 359.007812 205.53125 C 359.007812 204.894531 358.304688 204.808594 357.46875 204.808594 C 356.667969 204.808594 355.976562 204.921875 355.976562 205.519531 C 355.976562 206.113281 356.582031 206.273438 357.484375 206.273438 Z M 357.484375 206.273438 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 89.777344 85.808594 L 89.777344 86.550781 L 86.136719 86.550781 L 86.4375 87.148438 L 85.660156 87.148438 L 85.300781 86.488281 L 85.300781 85.808594 Z M 89.777344 85.808594 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 123.492188 84.316406 L 123.492188 86.011719 C 123.753906 86.042969 124.230469 86.125 124.414062 86.15625 C 124.261719 85.992188 124.152344 85.746094 124.152344 85.363281 C 124.152344 84.558594 124.726562 84.085938 125.53125 84.085938 C 126.339844 84.085938 127.066406 84.523438 127.066406 85.609375 C 127.066406 86.410156 126.644531 86.996094 125.921875 87.089844 L 125.921875 86.304688 C 126.238281 86.21875 126.453125 85.992188 126.453125 85.59375 C 126.453125 85.117188 126.109375 84.878906 125.597656 84.878906 C 125.125 84.878906 124.789062 85.066406 124.789062 85.578125 C 124.789062 86.003906 124.972656 86.183594 125.246094 86.296875 L 125.144531 87.015625 C 124.609375 86.898438 123.394531 86.726562 122.84375 86.660156 L 122.84375 84.199219 Z M 123.492188 84.316406 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 173.503906 86.335938 L 170.269531 86.335938 C 170.375 86.53125 170.484375 86.914062 170.511719 87.128906 L 169.910156 87.128906 C 169.835938 86.761719 169.605469 86.355469 169.339844 86.101562 L 169.339844 85.535156 L 173.5 85.535156 L 173.5 86.335938 Z M 173.503906 86.335938 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 171.40625 81.46875 C 172.507812 81.46875 173.582031 81.8125 173.582031 83.027344 C 173.582031 84.21875 172.550781 84.582031 171.433594 84.582031 C 170.320312 84.582031 169.28125 84.1875 169.28125 83.007812 C 169.28125 81.859375 170.261719 81.46875 171.40625 81.46875 Z M 171.425781 83.761719 C 172.195312 83.761719 172.953125 83.65625 172.953125 83.019531 C 172.953125 82.386719 172.246094 82.296875 171.414062 82.296875 C 170.613281 82.296875 169.917969 82.410156 169.917969 83.007812 C 169.910156 83.605469 170.523438 83.761719 171.425781 83.761719 Z M 171.425781 83.761719 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 220.019531 86.335938 L 216.785156 86.335938 C 216.890625 86.53125 217 86.914062 217.027344 87.128906 L 216.429688 87.128906 C 216.351562 86.761719 216.121094 86.355469 215.855469 86.101562 L 215.855469 85.535156 L 220.015625 85.535156 L 220.015625 86.335938 Z M 220.019531 86.335938 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 216.515625 81.789062 L 216.515625 83.484375 C 216.777344 83.515625 217.253906 83.597656 217.4375 83.628906 C 217.285156 83.464844 217.179688 83.21875 217.179688 82.835938 C 217.179688 82.03125 217.75 81.558594 218.558594 81.558594 C 219.367188 81.558594 220.089844 81.996094 220.089844 83.082031 C 220.089844 83.882812 219.671875 84.46875 218.945312 84.5625 L 218.945312 83.777344 C 219.265625 83.691406 219.480469 83.464844 219.480469 83.066406 C 219.480469 82.589844 219.136719 82.351562 218.621094 82.351562 C 218.152344 82.351562 217.8125 82.539062 217.8125 83.050781 C 217.8125 83.476562 218 83.65625 218.273438 83.769531 L 218.171875 84.488281 C 217.636719 84.371094 216.421875 84.199219 215.867188 84.132812 L 215.867188 81.675781 Z M 216.515625 81.789062 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 266.535156 87.121094 L 266.484375 87.121094 C 265.804688 87.121094 265.207031 86.773438 264.554688 85.882812 C 264.09375 85.269531 263.941406 85.089844 263.546875 85.089844 C 263.167969 85.089844 262.929688 85.28125 262.929688 85.6875 C 262.929688 86.132812 263.1875 86.308594 263.59375 86.371094 L 263.59375 87.136719 C 262.878906 87.070312 262.308594 86.609375 262.308594 85.679688 C 262.308594 84.652344 262.929688 84.289062 263.542969 84.289062 C 264.152344 84.289062 264.433594 84.558594 264.984375 85.324219 C 265.375 85.859375 265.640625 86.101562 265.875 86.183594 L 265.875 84.132812 L 266.535156 84.234375 Z M 266.535156 87.121094 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 264.433594 80.472656 C 265.53125 80.472656 266.605469 80.816406 266.605469 82.03125 C 266.605469 83.222656 265.578125 83.585938 264.457031 83.585938 C 263.34375 83.585938 262.308594 83.191406 262.308594 82.011719 C 262.308594 80.859375 263.292969 80.472656 264.433594 80.472656 Z M 264.453125 82.765625 C 265.21875 82.765625 265.976562 82.65625 265.976562 82.023438 C 265.976562 81.386719 265.273438 81.300781 264.4375 81.300781 C 263.636719 81.300781 262.945312 81.414062 262.945312 82.011719 C 262.945312 82.605469 263.546875 82.765625 264.453125 82.765625 Z M 264.453125 82.765625 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 313.054688 87.121094 L 313.003906 87.121094 C 312.320312 87.121094 311.722656 86.773438 311.070312 85.882812 C 310.609375 85.269531 310.457031 85.089844 310.0625 85.089844 C 309.683594 85.089844 309.449219 85.28125 309.449219 85.6875 C 309.449219 86.132812 309.703125 86.308594 310.109375 86.371094 L 310.109375 87.136719 C 309.398438 87.070312 308.824219 86.609375 308.824219 85.679688 C 308.824219 84.652344 309.449219 84.289062 310.058594 84.289062 C 310.667969 84.289062 310.949219 84.558594 311.5 85.324219 C 311.890625 85.859375 312.15625 86.101562 312.390625 86.183594 L 312.390625 84.132812 L 313.054688 84.234375 Z M 313.054688 87.121094 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 309.550781 80.792969 L 309.550781 82.488281 C 309.808594 82.519531 310.285156 82.601562 310.472656 82.632812 C 310.320312 82.46875 310.210938 82.21875 310.210938 81.839844 C 310.210938 81.03125 310.78125 80.5625 311.589844 80.5625 C 312.398438 80.5625 313.121094 81 313.121094 82.085938 C 313.121094 82.886719 312.703125 83.472656 311.976562 83.566406 L 311.976562 82.777344 C 312.296875 82.695312 312.511719 82.46875 312.511719 82.066406 C 312.511719 81.589844 312.167969 81.355469 311.652344 81.355469 C 311.183594 81.355469 310.839844 81.539062 310.839844 82.054688 C 310.839844 82.480469 311.023438 82.65625 311.296875 82.773438 L 311.195312 83.488281 C 310.660156 83.375 309.449219 83.203125 308.894531 83.132812 L 308.894531 80.675781 Z M 309.550781 80.792969 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 356.453125 87.078125 C 355.945312 87.015625 355.339844 86.652344 355.339844 85.660156 C 355.339844 84.726562 355.878906 84.308594 356.453125 84.308594 C 356.957031 84.308594 357.195312 84.601562 357.300781 84.84375 L 357.316406 84.84375 C 357.425781 84.539062 357.699219 84.144531 358.335938 84.144531 C 358.957031 84.144531 359.644531 84.523438 359.644531 85.667969 C 359.644531 86.734375 358.996094 87.121094 358.449219 87.171875 L 358.449219 86.40625 C 358.761719 86.339844 359.035156 86.113281 359.035156 85.648438 C 359.035156 85.167969 358.722656 84.945312 358.328125 84.945312 C 357.890625 84.945312 357.648438 85.191406 357.648438 85.707031 L 357.648438 86.054688 L 357.039062 86.054688 L 357.039062 85.75 C 357.039062 85.285156 356.871094 85.097656 356.496094 85.097656 C 356.179688 85.097656 355.96875 85.292969 355.96875 85.6875 C 355.96875 86.136719 356.21875 86.265625 356.464844 86.320312 L 356.464844 87.078125 Z M 356.453125 87.078125 "
            />
            <path
                style=" stroke:none;fill-rule:nonzero;fill:rgb(70.980392%,70.980392%,71.372549%);fill-opacity:1;"
                d="M 357.464844 80.398438 C 358.5625 80.398438 359.640625 80.742188 359.640625 81.953125 C 359.640625 83.148438 358.609375 83.507812 357.488281 83.507812 C 356.375 83.507812 355.339844 83.117188 355.339844 81.933594 C 355.339844 80.785156 356.324219 80.398438 357.464844 80.398438 Z M 357.484375 82.691406 C 358.253906 82.691406 359.007812 82.582031 359.007812 81.945312 C 359.007812 81.3125 358.304688 81.222656 357.46875 81.222656 C 356.667969 81.222656 355.976562 81.335938 355.976562 81.933594 C 355.976562 82.53125 356.582031 82.691406 357.484375 82.691406 Z M 357.484375 82.691406 "
            />
            <g style="fill:rgb(90.196078%,0%,7.058824%);fill-opacity:1;">
                <use xlink:href="#glyph0-1" x="77.768487" y="68.753906" />
            </g>
            <path
                style="fill:none;stroke-width:0.75;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(11.372549%,12.54902%,53.333333%);stroke-opacity:1;stroke-miterlimit:10;"
                d="M 126.217667 108.548559 L 126.217667 116.032306 "
                transform="matrix(0.635899,0,0,0.635001,0.152319,0)"
            />
            <g style="fill:rgb(90.196078%,0%,7.058824%);fill-opacity:1;">
                <use xlink:href="#glyph0-1" x="364.948175" y="68.753906" />
            </g>
            <path
                style="fill:none;stroke-width:0.75;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(11.372549%,12.54902%,53.333333%);stroke-opacity:1;stroke-miterlimit:10;"
                d="M 577.829467 108.548559 L 577.829467 116.032306 "
                transform="matrix(0.635899,0,0,0.635001,0.152319,0)"
            />
            <g style="fill:rgb(90.196078%,0%,7.058824%);fill-opacity:1;">
                <use xlink:href="#glyph0-1" x="364.948175" y="236.527344" />
            </g>
            <path
                style="fill:none;stroke-width:0.75;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(11.372549%,12.54902%,53.333333%);stroke-opacity:1;stroke-miterlimit:10;"
                d="M 577.829467 344.758169 L 577.829467 351.241916 "
                transform="matrix(0.635899,0,0,0.635001,0.152319,0)"
            />
            <g style="fill:rgb(90.196078%,0%,7.058824%);fill-opacity:1;">
                <use xlink:href="#glyph0-1" x="77.768487" y="236.527344" />
            </g>
            <path
                style="fill:none;stroke-width:0.75;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(11.372549%,12.54902%,53.333333%);stroke-opacity:1;stroke-miterlimit:10;"
                d="M 126.217667 344.758169 L 126.217667 351.241916 "
                transform="matrix(0.635899,0,0,0.635001,0.152319,0)"
            />
        </g>
        <!-- 맨 아래 마이너스 플러스 소켓 부분 시작 -->
        <g class="pin-group">
            <g
                v-for="col in 30"
                :id="getSocketCode(415, col)"
                class="pin socket"
                @click="onClick(415, col - 1)"
                :key="'lp' + col"
            >
                <circle
                    class="pin socket"
                    :cx="9 * col + 80"
                    :cy="235"
                    r="2.5"
                />
                <rect
                    class="pin-cover terminal"
                    :x="9 * col + 76"
                    :y="231"
                    width="8"
                    height="8"
                ></rect>
            </g>
        </g>
        <g class="pin-group">
            <g
                v-for="col in 30"
                :id="getSocketCode(412, col)"
                class="pin socket"
                @click="onClick(412, col - 1)"
                :key="'lm' + col"
            >
                <circle
                    :cx="9 * col + 80"
                    :cy="226"
                    r="2.5"
                />
                <rect
                    class="pin-cover terminal"
                    :x="9 * col + 76"
                    :y="222"
                    width="8"
                    height="8"
                ></rect>
            </g>
        </g>
        <!-- 맨 아래 마이너스 플러스 소켓 부분 끝 -->
        <!-- 맨 위 마이너스 플러스 소켓 부분 시작 -->
        <g class="pin-group">
            <g
                v-for="col in 30"
                :id="getSocketCode(515, col)"
                class="pin socket"
                :key="'up' + col"
                @click="onClick(515, col - 1)"
            >
                <circle
                    :cx="9 * col + 80"
                    :cy="58"
                    r="2.5"
                />
                <rect
                    class="pin-cover terminal"
                    :x="9 * col + 76"
                    :y="54"
                    width="8"
                    height="8"
                ></rect>
            </g>
        </g>
        <g class="pin-group">
            <!-- <g
                :id="`${id}-umpin` + col"
                class="pin socket"
                v-for="col in 30"
                @click="onClick(512, col - 1)"
                :key="'um' + col"
            > -->
            <g
                v-for="col in 30"
                :id="getSocketCode(512, col)"
                class="pin socket"
                @click="onClick(512, col - 1)"
                :key="'um' + col"
            >
                <circle
                    :cx="9 * col + 80"
                    :cy="67"
                    r="2.5"
                />
                <rect
                    class="pin-cover terminal"
                    :x="9 * col + 76"
                    :y="63"
                    width="8"
                    height="8"
                ></rect>
            </g>
        </g>
        <!-- 맨 위 마이너스 플러스 소켓 부분 끝 -->

        <!-- A~E 소켓 부분 -->
        <g v-for="(group, col) in lpins" :key="'lpins' + col" class="pin-group">
            <g
                v-for="(item, row) in group"
                @click="onClick(row, col)"
                class="pin socket"
                :key="col * 5 + row"
                :id="getSocketCode(row, col)"
            >
                <circle
                    :cx="9 * col + 90"
                    :cy="195 - 9 * row"
                    r="2.5"
                />
                <rect
                    class="pin-cover terminal"
                    :x="9 * col + 86"
                    :y="191 - 9 * row"
                    width="8"
                    height="8"
                ></rect>
            </g>
        </g>
        <!--A~E 소켓부분 끝-->
        <!--F~J 소켓부분 시작-->
        <g v-for="(group, col) in upins" :key="'upins' + col" class="pin-group">
            <g
                v-for="(item, row) in group"
                @click="onClick(row + 5, col)"
                class="pin socket"
                :key="150 + col * 5 + row"
                :id="getSocketCode(row + 5, col)"
            >
                <circle
                    :cx="9 * col + 90"
                    :cy="130 - 9 * row"
                    r="2.5"
                />
                <rect
                    class="pin-cover terminal"
                    :x="9 * col + 86"
                    :y="126 - 9 * row"
                    width="8"
                    height="8"
                ></rect>
            </g>
        </g>
        <!--F~j 소켓부분 끝-->
        <component
            v-for="(item, index) in connection"
            :is="item.el"
            :data="item.data"
            :key="index"
        ></component>
        </g>
    </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  name: 'Breadboard',
  props: ['data'],
  mixins: [pins],
  data () {
    return {
      id: this.data.id,
      code: '',
      lpins: [],
      upins: [],
      connection: []
    }
  },
  mounted () {
    this.created()
    this.setPindata(this.data)
    this.code = this.namecode
  },
  methods: {
    onClick (row, col) {
      window.event.stopPropagation()
      store.commit('wire/createLines', {
        name: this.id,
        pin: this.getSocketCode(row, col)
      })
    },
    getSocketCode (row, col) {
      const pin = this.getLetter(row) + (col + 1)
      return this.pincode + pin.toString()
    },
    getLetter (value) {
      let suffix = ''
      if (value > 400) {
        suffix = parseInt(value / 100) === 5 ? 'U' : 'L'
        value = value % 100
      }
      return suffix + String.fromCharCode(65 + value)
    },
    created () {
      for (let col = 0; col < 30; col++) {
        this.lpins.push([])
        this.upins.push([])
        for (let row = 0; row < 5; row++) {
          this.lpins[col].push({ row, col })
          this.upins[col].push({ row, col })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.elct-breadboard {
    z-index: 3;
}
.pin-group {
    &:hover {
        fill: #5f4b8b;
    }
}
.pin-cover {
    display: none;
    stroke-width: 2px;
    stroke: black;
    fill: #ff6f61;
}
.pin {
    &:hover {
        fill: #ff6f61;
        cursor: pointer;
        .pin-cover {
            display: block;
        }
    }
}
.socket.highlight circle {
    fill: #ff6f61;
}
.socket.snapped circle {
    fill: rgb(73, 174, 73);
}
.wire {
    stroke: #000;
    stroke-width: 2px;

    &:hover {
        stroke: #ff6f61;
    }
}

text {
    font-size: 6px;
}

.name {
    font-size: 10px;
}
g.selected {
    path.border {
        stroke-width: 1px;
        stroke: #ff6f61;
    }
}
circle {
    stroke: #bbb;
    stroke-width: 1px;
}
</style>
